module.exports = __webpack_public_path__ + "static/media/collection_incomplete.43561290.svg";